import { Component, Input } from '@angular/core';
import { TopbarService } from 'src/services/topbar.service';

@Component({
  standalone: false,
  selector: 'app-view-topbar',
  templateUrl: './view-topbar.component.html',
  styleUrls: ['./view-topbar.component.scss']
})
export class ViewTopbarComponent {

  @Input() containerClass = 'container-xl';

  constructor(public topbarService: TopbarService) { }

}
